import { createAsyncThunk } from '@reduxjs/toolkit';

import generateLogger from '@travel/logger';

import { getDomCouponAPI } from './api';

import type { ApiClient } from '@travel/api-client';
import type { CouponParams, CouponResponse } from '@travel/traveler-core/store/dom-coupon/types';

const logger = generateLogger();

type ThunkExtra = {
  apiClient: ApiClient;
  history?: any;
  req?: any;
  res?: any;
};

// Extended params with providerId (hotel number)
export type FetchDomCouponParams = CouponParams & {
  providerId: number;
};

// Async thunk for fetching coupon data
export const fetchDomCoupon = createAsyncThunk<
  CouponResponse,
  FetchDomCouponParams,
  { extra: ThunkExtra; rejectValue: any }
>('domCoupon/fetch', async (params, { extra, rejectWithValue }) => {
  const { apiClient } = extra;
  const { providerId, ...couponParams } = params;

  try {
    const response = await getDomCouponAPI(apiClient, couponParams);
    return response;
  } catch (error: any) {
    logger.error(`Fetch Coupon Error for provider ${providerId}`, error);
    return rejectWithValue({
      message: error?.message ?? String(error),
      name: error?.name,
      status: error?.status,
    });
  }
});
